/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import WatchNavbar from "components/Navbars/WatchNavbar.js";
import Footer from "components/Footer/Footer.jsx";
import routes from "routes.js";

class Page extends React.Component {
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/watch") {
        return (
          <Route
            exact={true}
            path={prop.layout + prop.path}
            component={prop.component.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getActiveRoute = routes => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  getFullPageName = routes => {
    let pageName = this.getActiveRoute(routes);
    switch (pageName) {
      case "Movies":
        return "movies";
      default:
        return "Default Brand Text";
    }
  };
  componentDidMount() {
    document.documentElement.classList.remove("nav-open");
  }
  render() {

    const style = {
        top: 0,
        left: 0,
        display: 'flex',
        zIndex: 1000,
        position: 'sticky',
    }

    return (
      <>
        <div className="wrapper wrapper-full-page" ref="fullPages">
          <WatchNavbar brandText={this.getActiveRoute(routes) + " Page"} />
          <div style={style} className={"full-page " + this.getFullPageName(routes)}>
            <Switch>
              {this.getRoutes(routes)}
            </Switch>
          </div>
        </div>
      </>
  );
  }
}

export default Page;
